export const POSTING_CREATE_SHEET = 'posting_create_sheet';
export const COMPLETED_CREATE_SHEET = 'completed_create_sheet';
export const SHEET_CREATION_FAILED = 'sheet_creation_failed';
